/****** create file by codeGen ******/
import { action, observable, runInAction } from 'mobx';

import { Remote } from '@/util';

class PushHome {
  // 列表数据
  @observable tableData = {
    list: [],
    total: 0,
    pageNum: 1,
    pageSize: 10,
  };
  @observable flowListData = {
    list: [],
    total: 0,
    pageNum: 1,
    pageSize: 10,
  };

  @observable shopList = [];

  @action queryList = async (params) => {
    let res = {};
    try {
      res = await Remote.post('/activityInfo/queryPushPadPageList.do', params);
    } catch (error) {}

    let list = [];
    if (res.code === 0 && res.success && Array.isArray(res.data?.list)) {
      list = res.data.list;
    }
    runInAction(() => {
      this.tableData = {
        list,
        total: res.data?.total || 0,
        pageNum: res.data?.pageNum || 1,
        pageSize: res.data?.pageSize || 10,
      };
    });
    return res;
  };

  @action ddlPushPad = async (params) => {
    let res = {};
    try {
      res = await Remote.post('/activityInfo/ddlPushPad.do', params);
    } catch (error) {}

    return res;
  };
}

export default new PushHome();
